import { render, staticRenderFns } from "./ContractAddendumDetail.vue?vue&type=template&id=3451a228&"
import script from "./ContractAddendumDetail.vue?vue&type=script&lang=js&"
export * from "./ContractAddendumDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports